import Vue from 'vue'
import Vuex from 'vuex'
// import axios from 'axios'
import { Lambda } from 'aws-sdk'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    username: '',
    auth: false,
    token: '',
    idtoken: '',
    refresh: '',
    apiurl: 'https://app5oy8hu1.execute-api.us-east-1.amazonaws.com/dev/items',
    modal: false,
    modalContent: '',
    nav: false,
    admin: false,
    appclientid: '',
    posts: [],
    headerclass: '',
    policy: null,
    activePost: {},
    activePostSlug: '',
  },
  mutations: {
    signIn (state) {
      state.auth = true
    },
    signOut (state) {
      state.auth = false
      state.admin = false
    },
    setUserName (state, params) {
      const { user, session } = params
      console.log(user)
      if (user === '') {
        state.username = ''
        state.idtoken = ''
        state.token = ''
        state.appclientid = ''
        return null
      }
      state.username = user.username
      state.idtoken = session.getIdToken().getJwtToken()
      state.token = session.getAccessToken().getJwtToken()
      const pool = session.getIdToken().payload['cognito:groups']
      if (pool) {
        state.appclientid = session.accessToken.payload.client_id
        if (pool.includes('admin')) {
          state.admin = true
        }
      }

    },
    setToken (state, tokens) {
      state.token = tokens.token
      state.idtoken = tokens.idtoken
      state.refresh = tokens.refresh
    },
    openModal(state) {
      state.modal = true
    },
    closeModal (state) {
      state.modal = false
      state.modalContent = ''
    },
    openNav(state) {
      state.nav = true
    },
    closeNav(state) {
      state.nav = false
    },
    addPostData(state, data) {
      state.posts = data
    },
    setHeaderClass(state, classname) {
      state.headerclass = classname
    },
    setActivePost(state, slug) {
      state.activePostSlug = slug;
      for (var i = 0; i < state.posts.length; i++) {
        const post = state.posts[i];
        if (post.slug.S === slug) {
          state.activePost = post
          console.log(state.activePost)
          return post
        }
      }
    },
    postBlog(state, postdata) {
      const { title, author, content, status, slug, created, excerpt, featuredImage } = postdata

      if ( !title || !author || !content || !status || !slug ) {
        alert("Please fill in all fields.");
        return null
      }

      const nowdate = new Date()
      const monthNum = nowdate.toLocaleString('en-us', { month: '2-digit' });
      const year = nowdate.toLocaleString('en-us', { year: 'numeric' });
      const day = nowdate.toLocaleString('en-us', { day: '2-digit' });
      const modified = `${year}-${monthNum}-${day}`;

      const blogData = {
        title: title,
        author: author,
        content: content,
        status: status,
        token: state.token,
        appclientid: state.appclientid,
        created: created,
        modified: modified,
        excerpt: excerpt,
        featuredImage: featuredImage,
        slug: slug
      }
      console.log('BlogData', blogData)

      let lambda = new Lambda();
      let params = {
        FunctionName: 'lexikitchen-dev-postBlog',
        Payload: JSON.stringify({
          postdata: blogData,
        })
      }
      lambda.invoke(params, (err, resp) => {
        if (err) {
          console.error('Post Blog Error: ',err)
          return resp
        } else {
          console.log('Blog Posted.', resp)
          return resp
        }
      })



      // const apiurl = 'https://app5oy8hu1.execute-api.us-east-1.amazonaws.com/dev/blog/post'
      //
      // const init = {
      //   headers: {
      //     "Content-Type": 'application/json',
      //     "X-Api-Key": "NhLutvx5gP2646WFTQ8Ds1i8jHqQ0fILaHUZ7hEs",
      //     "X-Amz-Security-Token": state.token,
      //     "Authorization": state.token
      //   },
      //   postdata: {
      //     title: title,
      //     author: author,
      //     content: content,
      //     status: status,
      //     token: state.token,
      //     appclientid: state.appclientid,
      //     created: created,
      //     modified: modified,
      //     excerpt: excerpt,
      //     slug: slug
      //   }
      // }
      // console.log(init)
      //
      // axios
      //   .post(apiurl, init)
      //   .then( response => {
      //     console.log('Post response');
      //     console.log(response);
      //   })
    }
  },
  actions: {

  }
})
